import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { faA, faAlignCenter, faAlignJustify, faAlignLeft, faAlignRight, faBold, faIndent, faItalic, faList, faListOl, faOutdent, faUnderline } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { renderToString } from 'react-dom/server';
export const BASE_SUMMERNOTE_OPTIONS = {
  minHeight: 80,
  focus: false,
  fontSizes: ['8', '9', '10', '11', '12', '14', '16', '18', '24', '36', '48', '64'],
  icons: {
    bold: renderToString(<FontAwesomeIcon icon={faBold} />),
    underline: renderToString(<FontAwesomeIcon icon={faUnderline} />),
    italic: renderToString(<FontAwesomeIcon icon={faItalic} />),
    unorderedlist: renderToString(<FontAwesomeIcon icon={faList} />),
    orderedlist: renderToString(<FontAwesomeIcon icon={faListOl} />),
    alignLeft: renderToString(<FontAwesomeIcon icon={faAlignLeft} />),
    alignCenter: renderToString(<FontAwesomeIcon icon={faAlignCenter} />),
    alignRight: renderToString(<FontAwesomeIcon icon={faAlignRight} />),
    alignJustify: renderToString(<FontAwesomeIcon icon={faAlignJustify} />),
    indent: renderToString(<FontAwesomeIcon icon={faIndent} />),
    outdent: renderToString(<FontAwesomeIcon icon={faOutdent} />),
    caret: renderToString(<FontAwesomeIcon icon={faCaretDown} />),
    font: renderToString(<FontAwesomeIcon icon={faA} />)
    // Summernote.IconsOptions is in TODO state and broken hence we work around it
  } as unknown as Summernote.IconsOptions
} satisfies Summernote.Options;
export const SUMMERNOTE_PATH_OPTIONS = {
  ...BASE_SUMMERNOTE_OPTIONS,
  // this will be needed with plugins for which we will have to import or extend the types
  // followingToolbar: false,
  toolbar: [
  // [groupName, [list of button]]
  ['style', ['bold', 'italic', 'underline']], ['color', ['color']], ['para', ['ul', 'ol', 'paragraph']]]
} satisfies Summernote.Options;
const OverridePopover: Summernote.Options['popover'] = {
  image: [['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']], ['float', ['floatLeft', 'floatRight', 'floatNone']], ['remove', ['removeMedia']], ['custom', ['imageAttributes']]],
  link: [['link', ['linkDialogShow', 'unlink']]],
  table: [['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']], ['delete', ['deleteRow', 'deleteCol', 'deleteTable']], ['custom', ['tableStyles']]],
  air: [['color', ['color']], ['font', ['bold', 'underline', 'clear']], ['para', ['ul', 'paragraph']], ['table', ['table']], ['insert', ['link', 'picture']], ['view', ['fullscreen', 'codeview']]]
};
const ImageAttributes = {
  icon: '<i class="note-icon-pencil"/>',
  figureClass: 'figureClass',
  figcaptionClass: 'captionClass',
  captionText: 'Caption Goes Here.',
  manageAspectRatio: true
};
export const SUMMERNOTE_TASK_OPTIONS = {
  ...BASE_SUMMERNOTE_OPTIONS,
  // this will be needed with plugins for which we will have to import or extend the types
  followingToolbar: true,
  toolbar: [
  // [groupName, [list of button]]
  ['style', ['bold', 'italic', 'underline']], ['font', ['strikethrough', 'superscript', 'subscript', 'fontname']], ['fontsize', ['fontsize']], ['color', ['color']], ['para', ['ul', 'ol', 'listStyles', 'paragraph']], ['height', ['height']], ['insert', ['picture', 'link', 'table', 'video']], ['misc', ['codeview']], ['code', ['code']]],
  imageAttributes: ImageAttributes,
  popover: OverridePopover
} satisfies Summernote.Options;
export const SUMMERNOTE_QUESTION_OPTIONS = {
  minHeight: 80,
  airMode: true,
  disableDragAndDrop: true,
  placeholder: 'Write your question here...',
  popover: OverridePopover
} satisfies Summernote.Options;